import { LinearProgress } from '@material-ui/core';
import { ApexOptions } from 'apexcharts';
import * as React from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import ReactApexChart from "react-apexcharts";
import { dashboardService } from '../../_services/dashboard.service';
import { toastr } from '../toastr/toastr';



export default function RecoveryDisposalChart(params: { search: any }) {
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({ recoveryWeights: [], disposalWeights: [] });
    const [recoveryWeight, setRecoveryWeight] = useState(null);
    const [disposalWeight, setDisposalWeight] = useState(null);


    React.useEffect(() => {
        fetchData();
    }, [params.search]);

    function fetchData() {
        var recoveryWeightSum = 0;
        var disposalWeightSum = 0;
        setLoading(true);

        return dashboardService.getReportChartRecoveryDisposal(params.search)
            .then(data => {
                setData(data);

                for (var i = 0; i < data.recoveryWeight.length; i++) {
                    recoveryWeightSum = recoveryWeightSum + data.recoveryWeight[i];
                }
                setRecoveryWeight(recoveryWeightSum);

                for (var i = 0; i < data.disposalWeight.length; i++) {
                    disposalWeightSum = disposalWeightSum + data.disposalWeight[i];
                }
                setDisposalWeight(disposalWeightSum);
            },
                (e) => {
                    console.log(e);
                    toastr.error("Something went wrong. Please try again later")
                })
            .finally(() => setLoading(false));
    }

    function format(num: number) {
        return String(num).replace(/(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g, '$1,');
    } 

    const chartData: ApexOptions = {

        series: [recoveryWeight, disposalWeight],
        chart: {
            width: 380,
            type: 'pie',
        },
        labels: ['Recovery (kg)', 'Disposal (kg)'],
        colors: ['#28a745', '#007bff'],
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 360,
                    offsetY: 20,
                    offsetX: -30
                },
                legend: {
                    position: 'bottom'
                },
                title: {
                    text: 'Recovery vs. Disposal',
                    align: 'center',
                    offsetY: 0,
                    offsetX: 0
                },
            },
        }],
        legend: {
            horizontalAlign: 'right',
            offsetX: 0,
            offsetY: 150
        },
        title: {
            text: 'Recovery vs. Disposal',
            align: 'left',
            offsetX: 30,
        },
        tooltip: {
            y: {
                formatter: function (value) {
                    return format(value);
                }
            }
        },
        
    };

    return (
        <>
            {(recoveryWeight != 0 || disposalWeight != 0) &&
                <>
                    {isLoading && <LinearProgress />}
                    <ReactApexChart options={chartData} series={chartData.series} type="pie" width={380} />
                </>
            }
            {(recoveryWeight == 0 && disposalWeight == 0) &&
                <div>
                    <p style={{ textAlign: 'center' }}>No recovery or disposal data available for the chosen time period.</p>
                </div>
            }
        </>
    );



}